import { useState, useRef } from "react";
import { Upload, X, Loader2 } from "lucide-react";
import { api } from "@/contexts/AuthContext";
import { toast } from "sonner";

const API = process.env.REACT_APP_BACKEND_URL;

export function getFileUrl(pathOrUrl) {
  if (!pathOrUrl) return "";
  if (pathOrUrl.startsWith("http")) return pathOrUrl;
  return `${API}/api/files/${pathOrUrl}`;
}

export default function FileUpload({ label, accept, value, onChange, className = "" }) {
  const [uploading, setUploading] = useState(false);
  const inputRef = useRef(null);

  const handleUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const formData = new FormData();
      formData.append("file", file);
      const { data } = await api.post("/upload", formData);
      onChange(data.path);
      toast.success("File uploaded");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Upload failed");
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div className={className}>
      {label && <label className="text-xs uppercase tracking-wider text-white/40 mb-2 block">{label}</label>}
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={() => inputRef.current?.click()}
          disabled={uploading}
          className="flex items-center gap-2 px-3 py-2 bg-[#1A1A1A] border border-white/10 rounded text-sm text-white/60 hover:border-[#D4AF37]/50 transition-colors disabled:opacity-50"
        >
          {uploading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />}
          {uploading ? "Uploading..." : "Choose File"}
        </button>
        {value && (
          <div className="flex items-center gap-2 flex-1 min-w-0">
            <span className="text-xs text-white/40 truncate">{value.split("/").pop()}</span>
            <button type="button" onClick={() => onChange("")} className="text-white/30 hover:text-red-400"><X className="w-3 h-3" /></button>
          </div>
        )}
      </div>
      <input ref={inputRef} type="file" accept={accept} onChange={handleUpload} className="hidden" />
      {value && accept?.includes("image") && (
        <img src={getFileUrl(value)} alt="" className="mt-2 h-20 object-cover rounded border border-white/10" />
      )}
    </div>
  );
}
